import Fab from "@mui/material/Fab";
import Badge from "@mui/material/Badge";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useLang } from "../i18n/LangContext";
import { useAppState } from "../state/AppState";
import { todayIso } from "../state/filters";

interface FilterFabProps {
  onClick: () => void;
  active: boolean;
}

export function FilterFab({ onClick, active }: FilterFabProps) {
  const { t } = useLang();
  const { filters } = useAppState();

  // Count non-default filter values for the badge. `date` matches the
  // initial value (today) by default so it shouldn't count until the
  // user changes it.
  const today = todayIso();
  const count =
    (filters.q ? 1 : 0) +
    (filters.species ? 1 : 0) +
    (filters.method ? 1 : 0) +
    (filters.onlyInSeason ? 1 : 0) +
    (filters.date && filters.date !== today ? 1 : 0) +
    (filters.enabledSources.size < 6 ? 1 : 0);

  // Badge wraps the Fab with `overlap="circular"`, so the count sits on
  // the Fab's circular edge — close enough to read as "this Fab has N
  // active filters" without floating off into space. No box-shadow stroke
  // (the red bg + white digit have enough contrast on their own).
  return (
    <Badge
      badgeContent={count}
      color="error"
      overlap="circular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      invisible={count === 0}
      sx={{
        position: "fixed",
        right: "calc(16px + var(--sar))",
        bottom: "calc(20px + var(--sab))",
        zIndex: 7,
        opacity: active ? 0 : 1,
        pointerEvents: active ? "none" : "auto",
        transition: "opacity .2s ease",
        "& .MuiBadge-badge": {
          zIndex: 10000,
          fontSize: 11,
          fontWeight: 700,
          minWidth: 20,
          height: 20,
          padding: "0 6px",
        },
      }}
    >
      <Fab
        className="filter-fab"
        color="primary"
        data-active={active}
        aria-label={t("toggleFilters")}
        onClick={onClick}
      >
        <FilterAltIcon sx={{ color: "common.white" }} />
      </Fab>
    </Badge>
  );
}
